<template>
  <b-modal :active.sync="opened" :full-screen="isFullScreen" width="500px">
    <div class="card">
      <div class="card-content tw-p-6">
        <validation-observer
          @submit.prevent="submit"
          ref="report"
          tag="form"
          v-slot="{ valid }"
        >
          <validation-provider
            vid="feedback"
            rules="required|min:6|max:1500"
            name="feedback"
            v-slot="{ errors }"
          >
            <b-field
              :message="errors"
              :type="{ 'is-danger': errors.length }"
              class="is-marginless"
            >
              <b-input
                rows="10"
                v-model="form.feedback"
                placeholder="Write something..."
                type="textarea"
              >
              </b-input>
            </b-field>
          </validation-provider>

          <div class="columns tw-mt-3">
            <div class="column"></div>
            <div class="column is-narrow">
              <b-button
                :disabled="!valid || submitting"
                :loading="submitting"
                native-type="submit"
                type="is-primary"
              >
                Submit report
              </b-button>
            </div>
          </div>
        </validation-observer>
      </div>
    </div>
  </b-modal>
</template>

<script>
import PostReport from '@/models/PostReport'
import CommentReport from '@/models/CommentReport'
import Post from '@/models/Post'
import Comment from '@/models/Comment'
import ModalMixin from '@/utils/mixins/modal'

export default {
  mixins: [ModalMixin],
  props: {
    item: {
      type: [Post, Comment]
    }
  },
  data() {
    return {
      opened: false,
      submitting: false,
      form: {
        feedback: ''
      }
    }
  },
  computed: {
    modelName() {
      const resource = this.item.resource()
      return resource.charAt(0).toUpperCase() + resource.slice(1, -1)
    }
  },
  methods: {
    open() {
      this.form = {
        feedback: ''
      }
      this.opened = true
    },
    submit() {
      this.submitting = true
      let report = null
      if (this.item instanceof Post) {
        report = new PostReport(this.form).for(this.item)
      } else {
        report = new CommentReport(this.form).for(this.item)
      }
      report
        .save()
        .then(response => {
          this.$buefy.snackbar.open({
            message: this.modelName + ' reported.',
            type: 'is-success',
            position: 'is-top'
          })
          this.opened = false
          this.$emit('reported')
        })
        .catch(({ response }) => {
          if (response.data && response.data.errors) {
            this.$refs.report.setErrors(response.data.errors)
          }
        })
        .then(() => {
          this.submitting = false
        })
    }
  }
}
</script>
